export default "__VITE_ASSET__DJcGbMnK__"